import Button from '../components/button/Button';
import Icon from '../components/icon/Icon';
import P from '../components/texts/p/P';
import { getFiscalIdConfig } from './fiscalIdentifier';
import type { TenantCountry } from './countryConfig';

const formatNumber = (value: number | null | undefined): string => {
  if (value == null) return '0';
  return value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  const d = new Date(value + 'T00:00:00');
  return d.toLocaleDateString('es-AR');
};

export const getMonetizedAvalesColumns = (
  onEnter: (row: any) => void,
  country?: TenantCountry | string | null
) => {
  const fiscalId = getFiscalIdConfig(country);
  return [
    {
      name: 'Número de aval',
      selector: (row: any) => row.guarantee_number,
      sortable: false,
      width: '130px',
    },
    {
      name: 'Razón social',
      selector: (row: any) => row.company_name,
      sortable: false,
      grow: 2,
      cell: (row: any) => (
        <P withMargin={false} type='3' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {row.company_name}
        </P>
      ),
    },
    {
      name: fiscalId.label,
      selector: (row: any) => row.cuit,
      sortable: false,
      width: '140px',
    },
    {
      name: 'Tipo de garantía',
      selector: (row: any) => row.guarantee_type,
      sortable: false,
      width: '170px',
    },
    {
      name: 'Fecha emisión',
      selector: (row: any) => row.issue_date,
      sortable: false,
      width: '120px',
      cell: (row: any) => formatDate(row.issue_date),
    },
    {
      name: 'F. monetización',
      selector: (row: any) => row.monetization_date,
      sortable: false,
      width: '130px',
      cell: (row: any) => formatDate(row.monetization_date),
    },
    {
      name: 'Estado',
      selector: (row: any) => row.status,
      sortable: false,
      width: '110px',
    },
    {
      name: 'Cobrada',
      selector: (row: any) => row.collected,
      sortable: false,
      width: '80px',
      center: true,
    },
    {
      name: 'Moneda',
      selector: (row: any) => row.currency,
      sortable: false,
      width: '80px',
    },
    {
      name: 'Activo',
      selector: (row: any) => row.asset_name,
      sortable: false,
      width: '140px',
      cell: (row: any) => row.asset_name || '—',
    },
    {
      name: 'Cantidad',
      selector: (row: any) => row.asset_quantity,
      sortable: false,
      width: '100px',
      right: true,
      cell: (row: any) => row.asset_quantity != null ? formatNumber(row.asset_quantity) : '—',
    },
    {
      name: 'Cotiz. activo',
      selector: (row: any) => row.asset_quotation,
      sortable: false,
      width: '120px',
      right: true,
      cell: (row: any) => row.asset_quotation != null ? formatNumber(row.asset_quotation) : '—',
    },
    {
      name: 'Monto bruto',
      selector: (row: any) => row.gross_amount,
      sortable: false,
      width: '130px',
      right: true,
      cell: (row: any) => formatNumber(row.gross_amount),
    },
    {
      name: 'Saldo vigente',
      selector: (row: any) => row.current_balance,
      sortable: false,
      width: '130px',
      right: true,
      cell: (row: any) => formatNumber(row.current_balance),
    },
    {
      name: 'Monto afrontado',
      selector: (row: any) => row.confronted_amount,
      sortable: false,
      width: '140px',
      right: true,
      cell: (row: any) => formatNumber(row.confronted_amount),
    },
    {
      name: 'Monto honrado',
      selector: (row: any) => row.honored_amount,
      sortable: false,
      width: '130px',
      right: true,
      cell: (row: any) => formatNumber(row.honored_amount),
    },
    {
      name: '',
      width: '90px',
      center: true,
      cell: (row: any) => (
        <Button
          variant='tertiary'
          onClick={() => onEnter(row)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <P withMargin={false} type='3' variant='secondary-1'>Entrar</P>
            <Icon name='view_outline' variant='secondary-1' width={16} height={16} />
          </div>
        </Button>
      ),
    },
  ];
};
